<template>
    <div class="modal-out">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">购物车({{elderlyName}})</div>
                <button type="button" class="btn-close" @click="closeSelf">X</button>
            </div>
            <div class="modal-body" style="height: 400px;">

              <el-card class="box-card" shadow="never">
                <div slot="header" class="clearfix">
                  <span>商品</span>
                </div>

                <el-table :data="listBeforeCartBusinessDTO" style="width: 100%" border stripe max-height='450'>

                  <el-table-column label="标题" width="150" fixed="left">
                    <template slot-scope="scope">
                      <template v-for="item in scope.row.listBeforeCartGoodsDTO">
                        <div :key="item.goodsName" >{{item.goodsName}}</div>
                      </template>
                    </template>
                  </el-table-column>

                  <el-table-column label="图片" width="60">
                    <template slot-scope="scope">
                      <template v-for="item in scope.row.listBeforeCartGoodsDTO">
                        <div :key="item.goodsName" >
                          <el-popover placement="right" title="" trigger="click" v-if="imgUrl+item.goodsHead">
                            <img :src="imgUrl+item.goodsHead"  style="width: 500px"/>
                            <img slot="reference" :src="imgUrl+item.goodsHead" style="width:100%">
                          </el-popover>
                        </div>
                      </template>
                    </template>
                  </el-table-column>

                  <el-table-column label="数量" width="60">
                    <template slot-scope="scope">
                      <template v-for="item in scope.row.listBeforeCartGoodsDTO">
                        <div :key="item.number" >{{item.number}}</div>
                      </template>
                    </template>
                  </el-table-column>
                  <el-table-column label="单价" width="60">
                    <template slot-scope="scope">
                      <template v-for="item in scope.row.listBeforeCartGoodsDTO">
                        <div :key="item.number" >{{item.beforeCartGoodsPriceDTO.price}}</div>
                      </template>
                    </template>
                  </el-table-column>
                  <el-table-column prop="price" label="总价" width="80"></el-table-column>

                  <!-- <el-table-column prop="businessName" label="商家" width="150"></el-table-column>-->

                  <el-table-column label="类型" width="150">
                    <template slot-scope="scope">
                      <span v-if="scope.row.goodsType == 1">普通商品</span>
                      <span v-if="scope.row.goodsType == 2">服务不可合并</span>
                      <span v-if="scope.row.goodsType == 3">服务可合并</span>
                    </template>
                  </el-table-column>

                  <el-table-column prop="planTime" :formatter="timefilter" width="200" label="预约时间"></el-table-column>

                  <el-table-column label="操作" fixed="right" width="200">
                      <template slot-scope="scope">
                        <template v-for="item in scope.row.listBeforeCartGoodsDTO">
                          <div :key="item.number" style="padding-bottom: 5px;">
                            <el-button type="primary" size="small" @click="handleCartEdit(item)">编辑</el-button>
                            <el-button type="danger" size="small" @click.native.prevent="handleDelete(item.beforeCartGoodsCode)">删除</el-button>
                          </div>
                        </template>
                      </template>
                  </el-table-column>

                </el-table>

              </el-card>

              <el-card class="box-card" shadow="never" :body-style="cardBodyStyle">
                  <div slot="header" class="clearfix">
                      <span>地址</span>
                  </div>

                  <el-table
                      :data="addressInfo"
                      style="width: 100%;" border stripe max-height='450' v-if="addressInfo.length>0">
                      <el-table-column prop="receiveName" label="名称" width="150"></el-table-column>
                      <el-table-column prop="receivePhone" label="手机号"></el-table-column>
                      <el-table-column prop="areaNamePath" label="地区"></el-table-column>
                      <el-table-column prop="receiveAddress" width="200" label="详细地址"></el-table-column>
                      <el-table-column label="操作">
                          <template slot-scope="scope">
                              <el-button type="primary" size="small" @click="showAddress(scope.$index, scope.row)">更换</el-button>
                          </template>
                      </el-table-column>
                  </el-table>
                  <el-button type="primary" v-if="addressInfo.length==0" style="width:30%;margin-bottom:20px;" @click="showAddress">选择地址</el-button>

              </el-card>

            </div>
            <div class="modal-footer">
                <el-button :loading="loading" type="primary" @click="confirm()">提交</el-button>
            </div>
        </div>
        <CartEdit ref="myCartEdit" v-show="showModalCartEdit" v-on:closeCartEdit="closeCartEdit" v-on:getGoods="getGoods"></CartEdit>
        <Address ref="myAddress" v-show="showModalAddress" v-on:closeAddress="closeAddress" v-on:setAddress="setAddress"></Address>
    </div>
</template>

<script>

    import {timeStr,timefilters} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";
    import CartEdit from "./CartEdit"
    import Address from "./Address"

    export default {
        name: 'GetGood',
        data() {
            return {
                showModalCartEdit:false,
                showModalAddress:false,
                loading: false,
              listBeforeCartBusinessDTO:[],
                cardBodyStyle:{'text-align':'center'},
                addressInfo:[],
                imgUrl:this.$imgUrl,

                userAddressCode:'',
                totalItems:0,
                elderlyCode:'',

              elderlyName:'',
            }
        },
        components:{
            CartEdit,Address
        },
        methods: {
            init(row){
                this.addressInfo=[]
                this.elderlyCode=row.elderlyCode
              this.elderlyName = row.name;
                this.getGoods()
            },
            closeSelf() {
                this.$emit("closeCart");
            },
            handleCartEdit(item) {
                this.$refs.myCartEdit.init(item);
                this.showModalCartEdit = !this.showModalCartEdit;
            },
            handleDelete(beforeCartGoodsCode){
                this.$confirm('此操作将删除此商品, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$axios({
                        method: 'post',
                        url: this.$shopUrl+"AppCare/BeforeCartItemDelete",
                        data: {
                            sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                            timeStr:timeStr,
                            staffCode:getStaffCode(),
                            beforeCartGoodsCode:beforeCartGoodsCode,
                        }
                    }).then(
                        (response) => {
                            this.loading = false;
                            if (response.data.error == 0) {
                              this.getGoods();
                               this.$message({type: 'success', message: '删除成功!'});
                            }else if(response.data.error == 1){
                                this.$message.error(response.data.message)
                            }
                        }
                    )

                }).catch(() => {
                    //this.$message({type: 'info', message: '已取消删除'});
                });
            },

            showAddress(){
                this.$refs.myAddress.init(this.elderlyCode);
                this.closeAddress()
            },
            setAddress(address){
                this.addressInfo=[]
                this.addressInfo.push(address);
                this.userAddressCode=address.userAddressCode
            },
            confirm(){

              if(this.userAddressCode == ''){
                this.$message.info("选择地址");
                return;
              }

              this.loading = true;

              this.$axios({
                  method: 'post',
                  url: this.$shopUrl+"AppCare/BeforeCartSubmitBusiness",
                  data: {
                      sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                      timeStr:timeStr,
                      staffCode:getStaffCode(),
                      userAddressCode:this.userAddressCode,
                      elderlyCode:this.elderlyCode,
                    payType:'yue',
                    clientType:'business',
                  }
              }).then(
                  (response) => {
                      this.loading = false;
                      if (response.data.error == 0) {
                          this.closeSelf();
                          this.$emit("getList");
                      }else if(response.data.error == 1){
                          this.$message.error(response.data.message)
                      }
                  }
              )

            },

            timefilter(row){
                return timefilters(row.planTime)
            },
            closeCartEdit:function(){
                this.showModalCartEdit = !this.showModalCartEdit;
            },
            closeAddress:function(){
                this.showModalAddress = !this.showModalAddress;
            },
            getGoods(){
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"AppCare/BeforeCart",
                    data: {
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        timeStr:timeStr,
                        staffCode:getStaffCode(),
                        elderlyCode:this.elderlyCode
                    }
                }).then(
                    (response) => {
                        this.loading = false;
                        if (response.data.error == 0) {
                            this.listBeforeCartBusinessDTO=response.data.data.beforeCartDTO.listBeforeCartBusinessDTO;
                        }else if(response.data.error == 1){
                            this.$message.error(response.data.message)
                        }
                    }
                )
            },
        }
    }


</script>

